jQuery(document).ready(function($) {
    if($('.shopify-section--testimonials-se').length ) {
        $('.testimonial-slider-se').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '20%',
            adaptiveHeight: false,
            arrows: true,
            fade: false,
            speed:'500',
            prevArrow: `<svg class='previous slick-arrow' width="57" height="100" viewBox="0 0 57 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_123_798)">
              <path d="M50.0004 -0.000106812C51.3252 -0.000274658 52.6204 0.392464 53.722 1.12843C54.8237 1.86441 55.6823 2.91055 56.1893 4.13454C56.6963 5.35854 56.829 6.70542 56.5705 8.00481C56.312 9.30421 55.6739 10.4977 54.737 11.4345L16.1704 50.0001L54.737 88.5658C55.9932 89.822 56.699 91.5258 56.699 93.3024C56.699 94.1821 56.5257 95.0531 56.1891 95.8658C55.8524 96.6785 55.359 97.417 54.737 98.039C54.115 98.661 53.3765 99.1544 52.5638 99.4911C51.7511 99.8277 50.8801 100.001 50.0004 100.001C48.2238 100.001 46.52 99.2952 45.2638 98.039L1.9615 54.7367C0.705494 53.4804 -9.15527e-05 51.7766 -9.15527e-05 50.0001C-9.15527e-05 48.2236 0.705494 46.5199 1.9615 45.2635L45.2638 1.96126C45.8853 1.33858 46.6236 0.84478 47.4365 0.508202C48.2493 0.171616 49.1206 -0.00112915 50.0004 -0.000106812Z" fill="#8A0FCE"></path>
            </g>
            <defs>
              <clipPath id="clip0_123_798">
                <rect width="56.6987" height="100" fill="white" transform="translate(56.6982 100) rotate(-180)"></rect>
              </clipPath>
            </defs>
          </svg>`,
            nextArrow: `<svg class='next slick-arrow' width="57" height="100" viewBox="0 0 57 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_123_796)">
              <path d="M6.69786 100C5.373 100 4.07785 99.6075 2.97622 98.8716C1.87458 98.1356 1.01595 97.0895 0.508926 95.8655C0.00190182 94.6415 -0.13074 93.2946 0.127773 91.9952C0.386287 90.6958 1.02435 89.5023 1.96125 88.5655L40.5278 49.9999L1.96125 11.4342C0.705019 10.178 -0.000721927 8.47418 -0.000721927 6.6976C-0.000721927 5.81793 0.172542 4.94688 0.509177 4.13417C0.845812 3.32146 1.33923 2.58301 1.96125 1.96099C2.58327 1.33897 3.32172 0.845558 4.13443 0.508923C4.94713 0.172287 5.81819 -0.000976562 6.69786 -0.000976562C8.47444 -0.000976562 10.1782 0.704764 11.4345 1.96099L54.7367 45.2633C55.9927 46.5196 56.6983 48.2234 56.6983 49.9999C56.6983 51.7764 55.9927 53.4801 54.7367 54.7365L11.4345 98.0387C10.813 98.6614 10.0746 99.1552 9.26176 99.4918C8.44893 99.8284 7.57762 100.001 6.69786 100Z" fill="#8A0FCE"></path>
            </g>
            <defs>
              <clipPath id="clip0_123_796">
                <rect width="56.6987" height="100" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`,
          responsive: [
            {
                breakpoint: 991,
                settings: {
                    centerMode: false,
                    centerPadding: '0',
                    arrows: false,
                    adaptiveHeight: true
                }
            }
        ]
        });
    }
});

